// Cayda facts reused across /vs/ pages. Source of truth: PRICING_CHEATSHEET.md + landing copy.
// Prices are annual billing, per month. Owner is covered by the base fee; members bill on accepted invites.

export const CAYDA = {
  free: '2 sites · 50 notes/site · 3 members',
  pro: 'Pro $9 + $5/member',
  team: 'Team $14 + $6/member',
  proPrice: (members) => 9 + 5 * members,
  teamPrice: (members) => 14 + 6 * members,
};

export const ADV = {
  invisible: {
    icon: 'invisible',
    title: 'Invisible to visitors. Always.',
    body: 'Nothing renders for your audience on any plan. The feedback layer appears only for authenticated team members and the guests you invite. No launcher, no badge, no URL key to leak, no toggle to forget. Run it on production.',
  },
  realSite: {
    icon: 'site',
    title: 'Your real site, not a copy',
    body: 'One script tag on your own domain. Your team reviews the page that actually shipped, with their own session, so pages behind login, dashboards, checkout flows and single page apps just work.',
  },
  dashboard: {
    icon: 'dashboard',
    title: 'A dashboard built for triage',
    body: 'Kanban and list views, filters by status, priority, assignee and note type, bulk actions, threaded comments, an activity feed and CSV export. Manage feedback like a project, not a thread.',
  },
  pricing: {
    icon: 'pricing',
    title: 'Priced per collaborator, nothing else',
    body: 'A small base fee covers you; each accepted teammate is $5 to $6. No seat blocks, no page view meters, no per-site caps on paid plans, and guests on the Team plan never cost a member fee.',
  },
  capture: {
    icon: 'capture',
    title: 'Context captured automatically',
    body: 'Every note pins to the element and records a screenshot, page URL, browser, OS and viewport. Screen recording on the Team plan. Nobody has to remember to include the details.',
  },
  integrations: {
    icon: 'script',
    title: 'Notes become tickets where you work',
    body: 'Slack notifications on Pro. Jira, Asana and Linear on Team. A note on the page turns into an issue in your tracker without anyone retyping it.',
  },
  install: {
    icon: 'script',
    title: 'Thirty seconds on any stack',
    body: 'Paste a URL, drop in one script tag. One click install for WordPress and Shopify; one line for React, Next.js, Webflow, Squarespace, Wix or plain HTML. The script is SPA aware and adds no visitor overhead.',
  },
};
